import { useTranslation } from '@egw/i18n'
import { buildBasicCurrency, Currency, getCurrencySymbol } from '@egw/utils'
import { type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { InvestmentAccountType } from '@egw/api'
import { DEFAULT_CURRENCY_CODE } from '@egw/constants'
import { useTransferContextProvider } from '../../context'

export const HelperText: FC = () => {
  const { t } = useTranslation('features-transfer')

  const { fromFieldOption, fetchedAvailableBalance, fetchingAccountBalance } = useTransferContextProvider()

  const isEvergreen = fromFieldOption.display.isEvergreenAccount

  // Check if the account is an IRA
  const isIRA =
    fromFieldOption.accountType === InvestmentAccountType.TRADITIONAL_IRA ||
    fromFieldOption.accountType === InvestmentAccountType.ROTH_IRA

  // Check if the account is an IRA and has an iraWithdrawalAmount
  const availableForWithDrawal =
    isIRA && fromFieldOption.attributes && 'iraWithdrawal' in fromFieldOption.attributes
      ? fromFieldOption.attributes.iraWithdrawal?.withdrawalAmount
      : 0

  const iraWithdrawalAmount = buildBasicCurrency({
    amount: availableForWithDrawal ?? 0,
    currencyCode: DEFAULT_CURRENCY_CODE,
  })

  // Show Available Balance if User is Transferring Out
  const showAvailableBalance = !fetchingAccountBalance && fetchedAvailableBalance && isEvergreen && !isIRA

  const availableBalance = `${getCurrencySymbol(
    fetchedAvailableBalance?.currencyCode!,
  )}${Currency.integerCents.onlyMinus(fetchedAvailableBalance?.amount!)}`

  // If Available Balance per account selected is being fetched show skeleton
  if (fetchingAccountBalance)
    return (
      <div className="h-[0.875rem] w-full -mt-2">
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={1} height="100%" className="mb-10" />
        </SkeletonTheme>
      </div>
    )

  // If From Field Option has been selected show
  // Shows Available Balance Text
  return fromFieldOption.value ? (
    <p className="text-xs text-meta -mt-2">
      {!showAvailableBalance && !isIRA ? t('transfer.funds_available_in_days') : null}
      {showAvailableBalance
        ? t('transfer.available_balance', {
            availableBalance,
          })
        : null}
      {isIRA ? t('transfer.available_for_withdrawal', { iraWithdrawalAmount }) : null}
    </p>
  ) : null
}
